import { Button } from '@talentmesh/ui/components/button';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@talentmesh/ui/components/dialog';
import UIStrings from '@/Utils/UIStrings';

interface OneClickFallbackDialogProps {
    open: boolean;
    onContinue: () => void;
    onDismiss: () => void;
}

/**
 * Shown when a one-click submission comes back as a `Fallback`: the job ad was read but couldn't
 * be turned into a valid recruitment. Explains what happened and lets the recruiter either continue to manual
 * creation (with the extracted values pre-filled) or dismiss and stay on the entry screen.
 */
const OneClickFallbackDialog = ({ open, onContinue, onDismiss }: OneClickFallbackDialogProps) => {
    return (
        <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onDismiss()}>
            <DialogContent className="max-w-xl gap-4 p-6" showCloseButton={false} data-cy="one-click-fallback-dialog">
                <div className="flex flex-col gap-4">
                    <DialogTitle>{UIStrings.OneClickFallbackDialogTitle}</DialogTitle>
                    <DialogDescription>{UIStrings.OneClickFallbackDialogDescription}</DialogDescription>
                    <div className="flex flex-row items-center gap-2">
                        <Button
                            type="button"
                            variant="default-outline"
                            className="flex-1"
                            onClick={onDismiss}
                            data-cy="one-click-fallback-dismiss"
                        >
                            {UIStrings.OneClickFallbackDismiss}
                        </Button>
                        <Button
                            type="button"
                            variant="default"
                            className="flex-1"
                            onClick={onContinue}
                            data-cy="one-click-fallback-continue"
                        >
                            {UIStrings.OneClickFallbackContinue}
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default OneClickFallbackDialog;
